/*
  CUSTOM CODE: ADDED - filtri rapidi delle collezioni.

  Sopra la barra dei filtri c'e' la striscia delle misure (custom__collection-sizes)
  e dentro la barra le tendine veloci (custom__collection-chips). Sono tutti link
  ai filtri di Shopify: qui li facciamo lavorare senza ricaricare la pagina,
  passando dallo stesso motore del tema (FacetFiltersForm in facets.js).

  Il tema, dopo un filtro, ridisegna solo griglia, conteggio e filtri del
  pannello. Noi ci agganciamo a quel momento e ridisegniamo anche striscia,
  tendine, pannello Filtri e numerino sul tasto, prendendoli dalla stessa risposta.

  Il pannello Filtri si apre di lato: un clic fuori dal pannello lo chiude.
*/
(function () {
  if (window.__customCollectionFilters) return;
  window.__customCollectionFilters = true;

  var REFRESH_IDS = ['CollectionSizes', 'CollectionTypes', 'CollectionChips', 'FiltersCountBadge', 'FiltersPanel'];
  var openChip = null;

  function engine() {
    return typeof FacetFiltersForm !== 'undefined' && document.getElementById('product-grid')
      ? FacetFiltersForm
      : null;
  }

  function refreshFrom(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    REFRESH_IDS.forEach(function (id) {
      var here = document.getElementById(id);
      var there = doc.getElementById(id);
      if (!here) return;
      here.innerHTML = there ? there.innerHTML : '';
      here.classList.remove('is-loading');
    });
    reopen();
  }

  function patch() {
    var F = engine();
    if (!F || F.__customQuick) return;
    var original = F.renderProductGridContainer;
    F.renderProductGridContainer = function (html) {
      original.call(F, html);
      try {
        refreshFrom(html);
      } catch (e) {}
    };
    F.__customQuick = true;
  }

  function go(href) {
    var F = engine();
    var url = new URL(href, window.location.href);
    url.searchParams.delete('page');
    if (!F) {
      window.location.href = url.pathname + url.search;
      return;
    }
    REFRESH_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.add('is-loading');
    });
    F.renderPage(url.search.slice(1));
  }

  function closeChips(except) {
    document.querySelectorAll('.cchip.is-open').forEach(function (chip) {
      if (chip !== except) {
        chip.classList.remove('is-open');
        var b = chip.querySelector('[data-chip-btn]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function reopen() {
    if (!openChip) return;
    var chip = document.querySelector('.cchip[data-chip="' + openChip + '"]');
    if (!chip) return;
    chip.classList.add('is-open');
    var b = chip.querySelector('[data-chip-btn]');
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  function closePanel() {
    var closer = document.querySelector('.fpanel-top .drawer__button-close--facets') ||
      document.querySelector('.drawer__button-close--facets');
    if (closer) closer.click();
    return !!closer;
  }

  document.addEventListener('click', function (event) {
    // pannello Filtri aperto e clic fuori dal pannello: si chiude (e basta)
    var panelOpen = document.querySelector('.fpanel-top .drawer__container.menu-opening');
    if (
      panelOpen &&
      document.contains(event.target) &&
      !event.target.closest('.fpanel-top .drawer__content') &&
      !event.target.closest('.fpanel-top summary')
    ) {
      event.preventDefault();
      event.stopPropagation();
      closePanel();
      return;
    }

    // link di un filtro (misura, stanza, tema, artista)
    var link = event.target.closest('a[data-facet-link]');
    if (link) {
      event.preventDefault();
      go(link.getAttribute('href'));
      return;
    }

    // fasce di prezzo
    var price = event.target.closest('[data-price-preset]');
    if (price) {
      event.preventDefault();
      var params = new URLSearchParams(window.location.search);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      if (!price.hasAttribute('data-active')) {
        var min = price.getAttribute('data-min');
        var max = price.getAttribute('data-max');
        if (min) params.set('filter.v.price.gte', min);
        if (max) params.set('filter.v.price.lte', max);
      }
      go('?' + params.toString());
      return;
    }

    // apri / chiudi una tendina
    var btn = event.target.closest('[data-chip-btn]');
    if (btn) {
      event.preventDefault();
      var chip = btn.closest('.cchip');
      var willOpen = !chip.classList.contains('is-open');
      closeChips(chip);
      chip.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      openChip = willOpen ? chip.getAttribute('data-chip') : null;
      return;
    }

    // «Mostra N prodotti»: chiude il pannello con il tasto di chiusura del tema
    if (event.target.closest('[data-panel-close]')) {
      event.preventDefault();
      closePanel();
      return;
    }

    if (event.target.closest('[data-chip-close]')) {
      closeChips();
      openChip = null;
      return;
    }

    // clic fuori: chiude
    if (!event.target.closest('.cchip__pop') && !event.target.closest('.fpanel')) {
      closeChips();
      openChip = null;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeChips();
      openChip = null;
      if (document.querySelector('.fpanel-top .drawer__container.menu-opening')) closePanel();
    }
  });

  // "Hai gia' una cornice?" porta l'occhio sulla striscia
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-sizes-hint]')) return;
    var strip = document.querySelector('.csizes__strip');
    if (strip && strip.animate) {
      strip.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }],
        { duration: 320 }
      );
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
  window.addEventListener('load', patch);
})();
